<!-- Copyright (c) 2025 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="defaultstatuslist-main">
    <Menus :menu="menus" @menuClicked="handleMenuClick" />
    <div class="right-container">
      <TableBox
        title="All Default Status Lists"
        :tableData="statusList"
        :selectedRow.sync="selectedStatusList"
        v-if="reloadTable"
        :dataType="{ 'Status Count': 'number' }"
      />
    </div>
    <PopupEntry
      v-if="popupEntryShow"
      :show.sync="popupEntryShow"
      :title="popUpTitle"
      :requiredError="entryError"
      :errorMessages="errorMessage"
      :viewMode="popUpAction !== 'E' || popUpAction === 'N'"
      :successMessages="successMessages"
      :createdBy="createdBy"
      :updatedBy="updatedBy"
      @save="saveDefaultStatus"
    >
      <div class="popup-entry-container">
        <div class="popup-top-section">
          <Dropdown
            :items.sync="systemList"
            itemKey="Application Name"
            :selectedObject.sync="selectedSystem"
            placeholder="Select System Type"
            @selected="onSystemSelect"
            :isRequired="true"
            :errorMessage.sync="systemFieldErrorMessage"
            :isDisabled="popUpAction === 'E' || popUpAction === 'V'"
          />
          <Dropdown
            :items.sync="jobTypeList"
            itemKey="Description"
            :selectedObject.sync="selectedJobType"
            placeholder="Select Job Type"
            :isDisabled="
              popUpAction === 'E' || popUpAction === 'V' || selectedSystem === null || selectedSystem.length === 0
            "
            :isRequired="true"
            :errorMessage.sync="jobTypeFieldErrorMessage"
            @selected="validateCreateFields()"
          />
          <InputQuery
            :items.sync="customerList"
            itemKey="Customer Name"
            :selectedObject.sync="selectedCustomer"
            placeholder="Select Customer (Leave Blank for Default)"
            :isDisabled="
              popUpAction === 'E' || popUpAction === 'V' || selectedJobType === null || selectedJobType.length === 0
            "
            @selected="validateCreateFields()"
          />
        </div>

        <div class="defaultStatusTask-tablebox">
          <div class="defaultStatusTask-table-buttons">
            <button @click="onClickAddStatus" :disabled="viewMode">
              <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png" alt="Add Status" />
              Add Status
            </button>
            <button @click="onClickEditStatus" :disabled="viewMode">
              <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png" alt="Add Status" />
              Edit Status
            </button>
            <button @click="removeStatusClicked" :disabled="viewMode">
              <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png" alt="Delete Status" />
              Delete Status
            </button>
            <button :disabled="viewMode" @click="statusReorderingMenuMoveUpClicked">
              <img src="https://dsmlib.logistics.systems/Icons/icons8-up-arrow-26.png" alt="Move Up" />
              Move Up
            </button>
            <button :disabled="viewMode" @click="statusReorderingMenuMoveDownClicked">
              <img src="https://dsmlib.logistics.systems/Icons/icons8-down-arrow-26.png" alt="Move Down" />
              Move Down
            </button>
          </div>

          <div class="defaultStatusTask-table-main-content">
            <TableBox
              v-if="reloadTable"
              title="Selected Default Status Lists"
              :tableData.sync="defaultStatusList"
              :selectedRow.sync="selectedDefaultStatusList"
              :hideColumns.sync="hideColumns"
              :dataType="{ 'Last Update': 'datetime', '#': 'number', 'Due Duration': 'number' }"
            />
          </div>
        </div>
      </div>
    </PopupEntry>

    <div v-if="showAddNewStatusPopup" class="addNewStatus-popup-container">
      <div class="addNewStatus-popup">
        <InputQuery
          :items="addStatusList"
          itemKey="combined"
          descKey="combined"
          :selectedObject.sync="selectedAddStatus"
          placeholder="Select Status"
          :isDisabled="!isAddingStatus"
          :isRequired="true"
          :errorMessage.sync="requiredFieldsErrorMessage.selectedStatus"
        />

        <Dropdown
          :items.sync="cargoTypeList"
          itemKey="Description"
          :selectedObject.sync="selectedCargoType"
          placeholder="Select Cargo Type"
        />

        <Dropdown
          :items.sync="transModeList"
          itemKey="Description"
          :selectedObject.sync="selectedTransMode"
          placeholder="Select Transport Type"
        />

        <CheckBox title="DG Cargo?" :isChecked.sync="dgCargoChecked" />

        <BoxContainer
          title="Due Duration Fields"
          :isCheckBox="true"
          :isChecked.sync="dueDurationFieldTicked"
          @checkBoxClicked="resetBoxFields"
        >
          <Input
            placeholder="Duration"
            :inputValue.sync="dueDurationFields.dueDurationValue"
            validator="integer"
            :isDisabled="!dueDurationFieldTicked"
            :isRequired="dueDurationFieldTicked"
            :errorMessage.sync="requiredFieldsErrorMessage.dueDurationValue"
          />

          <Dropdown
            :items="dueDurationDropDown.dueDurationTypeList"
            itemKey="key"
            :selectedObject.sync="dueDurationFields.dueDurationTypeValue"
            placeholder="Select Duration Type"
            :isDisabled="!dueDurationFieldTicked"
            :isRequired="dueDurationFieldTicked"
            :errorMessage.sync="requiredFieldsErrorMessage.dueDurationTypeValue"
          />

          <Dropdown
            :items="dueDurationDropDown.dueDurationCompareList"
            itemKey="key"
            :selectedObject.sync="dueDurationFields.dueDurationCompareValue"
            placeholder="Select Duration Compare Value"
            :isDisabled="!dueDurationFieldTicked"
            :isRequired="dueDurationFieldTicked"
            :errorMessage.sync="requiredFieldsErrorMessage.dueDurationCompareValue"
          />

          <Dropdown
            :items="dueDurationDropDown.dueCompareDateFieldList"
            itemKey="representation"
            :selectedObject.sync="dueDurationFields.dueCompareDateFieldValue"
            placeholder="Select Date Field"
            :isDisabled="!dueDurationFieldTicked"
            :isRequired="dueDurationFieldTicked"
            :errorMessage.sync="requiredFieldsErrorMessage.dueCompareDateFieldValue"
          />
        </BoxContainer>
        <div class="addNewStatus-button">
          <button @click="addStatusAddButtonClick()">{{ isAddingStatus ? 'Add' : 'Edit' }}</button>
          <button @click="addStatusCancelButtonClick()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {},
  data: function () {
    return {
      menus: [
        {
          title: 'Create New Default Status List',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          key: 'MnuNew',
          visible: true,
          enabled: true,
        },
        {
          title: 'Edit Default Status List',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          key: 'MnuEdit',
          visible: true,
          enabled: true,
        },
        {
          title: 'Delete Default Status List',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          key: 'MnuDelete',
          visible: false,
          enabled: true,
        },
        {
          title: 'View Default Status List',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          key: '',
          visible: true,
          enabled: true,
        },
      ],

      //Inputs for jsonBody
      systemInput: '',
      customerInput: '',
      jobTypeInput: '',

      selectedTransMode: null,
      selectedCargoType: null,
      jobTypeList: [],
      customerList: [],
      transModeList: [],
      cargoTypeList: [],
      systemList: [],

      selectedSystem: null,
      selectedJobType: null,
      selectedCustomer: null,

      systemFieldErrorMessage: '',
      jobTypeFieldErrorMessage: '',

      statusList: [],
      selectedStatusList: [],

      defaultStatusList: [],
      selectedDefaultStatusList: [],
      reloadTable: true,
      hideColumns: [],

      popupEntryShow: false,
      popUpAction: '',
      popUpTitle: '',
      entryError: [],
      errorMessage: [],
      successMessages: [],
      viewMode: false,
      createdBy: '',
      updatedBy: '',

      addStatusList: [],
      selectedAddStatus: null,
      showAddNewStatusPopup: false,
      dgCargoChecked: false,
      dueDurationFields: {
        dueDurationValue: '0',
        dueDurationTypeValue: null,
        dueDurationCompareValue: null,
        dueCompareDateFieldValue: null,
      },
      dueDurationFieldTicked: false,
      dueDurationDropDown: {
        dueDurationTypeList: [
          { key: 'n: Minute', value: 'n' },
          { key: 'H: Hour', value: 'H' },
          { key: 'd: Day', value: 'd' },
          { key: 'W: Week', value: 'W' },
          { key: 'M: Month', value: 'M' },
        ],
        dueDurationCompareList: [
          { key: 'before', value: 'b' },
          { key: 'after', value: 'a' },
        ],
        dueCompareDateFieldList: [],
      },
      requiredFieldsErrorMessage: {
        //Using same key to make it simpler to modify error message
        selectedStatus: '',
        dueDurationValue: '',
        dueDurationTypeValue: '',
        dueDurationCompareValue: '',
        dueCompareDateFieldValue: '',
      },
      isAddingStatus: false,
    };
  },
  props: {},
  methods: {
    findSelectedIndex() {
      return this.defaultStatusList.findIndex((item) => item['#'] === this.selectedDefaultStatusList[0]['#']);
    },
    async latestStatusList() {
      this.statusList = await this.$apiCallV2('/DefaultStatusList/GetAllDefaultStatusList', {});
      this.statusList = this.statusList.map((item, index) => {
        return {
          '#': index + 1,
          ...item,
        };
      });
    },
    async sasControlFunction() {
      this.$fullscreenLoading('Checking Security Access');
      const sasControl = await this.$apiCallV2(
        `/SASControl/GetSASControlAccess?system=MASTER&page=Default Status List`,
      );
      sasControl.forEach((k) => {
        //key in menu same as control value from api
        const selectedMenu = this.menus.find((m) => m['key'] == k['Control']);
        if (selectedMenu) {
          selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
        }
      });
      this.$fullscreenLoading('');
    },
    validateCreateFields() {
      let error = false;
      if (this.selectedSystem === null) {
        this.systemFieldErrorMessage = 'Field Missing';
        error = true;
      }
      if (this.selectedJobType === null) {
        this.jobTypeFieldErrorMessage = 'Field Missing';
        error = true;
      }

      if (error) {
        this.viewMode = true;
        return;
      }

      this.$nextTick(() => {
        this.viewMode = false;
      });
    },
    resetBoxFields() {
      if (!this.dueDurationFieldTicked) {
        Object.keys(this.requiredFieldsErrorMessage).forEach((key) => {
          if (key !== 'selectedStatus') {
            this.requiredFieldsErrorMessage[key] = '';
          }
        });

        Object.keys(this.dueDurationFields).forEach((key) => {
          if (key !== 'dueDurationValue') {
            this.dueDurationFields[key] = null;
          } else {
            this.dueDurationFields[key] = '0';
          }
        });
      }
    },
    addStatusCancelButtonClick() {
      this.showAddNewStatusPopup = false;
      Object.keys(this.requiredFieldsErrorMessage).forEach((key) => (this.requiredFieldsErrorMessage[key] = ''));
      this.selectedAddStatus = null;
      this.selectedCargoType = null;
      this.selectedTransMode = null;
      this.dueDurationFieldTicked = false;
      Object.keys(this.dueDurationFields).forEach((key) => (this.dueDurationFields[key] = null));
      this.dueDurationFields.dueDurationValue = '0';
      this.dgCargoChecked = false;
    },
    addStatusAddButtonClick() {
      let hasErrors = false;

      if (this.selectedAddStatus === null) {
        this.requiredFieldsErrorMessage['selectedStatus'] = 'Field Missing';
        hasErrors = true;
      }
      if (this.dueDurationFieldTicked) {
        if (this.dueDurationFields.dueDurationValue === '0' || this.dueDurationFields.dueDurationValue == null) {
          this.requiredFieldsErrorMessage['dueDurationValue'] = 'Duration must be larger than 0';
          hasErrors = true;
        }
        for (const [key, value] of Object.entries(this.dueDurationFields)) {
          if (value === null && key !== 'dueDurationValue') {
            this.requiredFieldsErrorMessage[key] = 'Field Missing';
            hasErrors = true;
          }
        }
      }

      if (hasErrors) {
        return;
      }

      const seqStartAtZero = this.defaultStatusList[0]?.['SeqNo'] == 0 || false;
      this.systemInput =
        this.systemInput === '' ?
          this.popUpAction !== 'N' ?
            this.selectedStatusList[0]['System']
          : this.selectedSystem['System']
        : this.systemInput;

      this.customerInput =
        this.customerInput === '' ?
          this.popUpAction !== 'N' ?
            this.selectedStatusList[0]['Customer Code']
          : this.selectedCustomer?.['Customer Code'] || 'DEFAULT'
        : this.customerInput;

      this.jobTypeInput =
        this.jobTypeInput === '' ?
          this.popUpAction !== 'N' ?
            this.selectedStatusList[0]['Job Type']
          : this.selectedJobType['Job Type']
        : this.jobTypeInput;

      const durationType = {
        n: this.dueDurationValue === 1 ? 'minute' : 'minutes',
        H: this.dueDurationValue === 1 ? 'hour' : 'hours',
        d: this.dueDurationValue === 1 ? 'day' : 'days',
        W: this.dueDurationValue === 1 ? 'week' : 'weeks',
        M: this.dueDurationValue === 1 ? 'month' : 'months',
      };

      if (!this.isAddingStatus) {
        const selectedStatusIndex = this.defaultStatusList.findIndex(
          (item) => item['#'] === this.selectedDefaultStatusList[0]['#'],
        );
        this.defaultStatusList[selectedStatusIndex]['Category'] = this.selectedAddStatus['Group Desc'];
        this.defaultStatusList[selectedStatusIndex]['Cargo Type'] = this.selectedCargoType?.['Cargo Type'] ?? null;
        this.defaultStatusList[selectedStatusIndex]['Compare'] =
          this.dueDurationFields.dueDurationCompareValue?.['key'] || null;
        this.defaultStatusList[selectedStatusIndex]['Customer'] = this.customerInput;
        this.defaultStatusList[selectedStatusIndex]['DGCargo?'] = this.dgCargoChecked ? '1' : '0';
        this.defaultStatusList[selectedStatusIndex]['Date Field'] =
          this.dueDurationFields.dueCompareDateFieldValue?.['representation'] || null;
        this.defaultStatusList[selectedStatusIndex]['Due Duration'] = Number(this.dueDurationFields.dueDurationValue);
        this.defaultStatusList[selectedStatusIndex]['DueCompareDateField'] =
          this.dueDurationFields.dueCompareDateFieldValue?.['DateField'] ?? null;
        this.defaultStatusList[selectedStatusIndex]['DueCompareTimeField'] =
          this.dueDurationFields.dueCompareDateFieldValue?.['TimeField'] ?? null;
        this.defaultStatusList[selectedStatusIndex]['DueDurationCompare'] =
          this.dueDurationFields.dueDurationCompareValue?.['value'] ?? null;
        this.defaultStatusList[selectedStatusIndex]['DueDurationType'] =
          this.dueDurationFields.dueDurationTypeValue?.['value'] ?? null;
        this.defaultStatusList[selectedStatusIndex]['Duration Type'] =
          durationType[this.defaultStatusList[selectedStatusIndex]['DueDurationType']] ?? null;
        this.defaultStatusList[selectedStatusIndex]['JobType'] = this.jobTypeInput;
        this.defaultStatusList[selectedStatusIndex]['Last Update'] = null;
        this.defaultStatusList[selectedStatusIndex]['Status Code'] = this.selectedAddStatus['Status'];
        this.defaultStatusList[selectedStatusIndex]['Status Description'] = this.selectedAddStatus['Status Desc'];
        this.defaultStatusList[selectedStatusIndex]['System'] = this.systemInput;
        this.defaultStatusList[selectedStatusIndex]['TransMode'] = this.selectedTransMode?.['Trans Mode'] ?? null;
        this.defaultStatusList[selectedStatusIndex]['Trans Mode'] = this.selectedTransMode?.['Description'] || null;
        this.defaultStatusList[selectedStatusIndex]['User'] = this.loginDetails.LoginUserId;
      } else {
        // duecomparefieldtable is set to null, statusgroup is from another table
        const postBody = {
          //For inserting to statustaskdefaults
          SeqNo: seqStartAtZero ? this.defaultStatusList.length : this.defaultStatusList.length + 1,
          Customer: this.customerInput,
          System: this.systemInput,
          JobType: this.jobTypeInput,
          TransMode: this.selectedTransMode?.['Trans Mode'] ?? null,
          DueDurationCompare: this.dueDurationFields.dueDurationCompareValue?.['value'] ?? null,
          DueDurationType: this.dueDurationFields.dueDurationTypeValue?.['value'] ?? null,
          DueCompareDateField: this.dueDurationFields.dueCompareDateFieldValue?.['DateField'] ?? null,
          DueCompareTimeField: this.dueDurationFields.dueCompareDateFieldValue?.['TimeField'] ?? null,
        };
        const display = {
          '#': seqStartAtZero ? postBody.SeqNo + 1 : postBody.SeqNo,
          'Status Code': this.selectedAddStatus['Status'],
          'Status Description': this.selectedAddStatus['Status Desc'],
          Category: this.selectedAddStatus['Group Desc'],
          'Cargo Type': this.selectedCargoType?.['Cargo Type'] ?? null,
          User: this.loginDetails.LoginUserId,
          'Last Update': null,
          'DGCargo?': this.dgCargoChecked ? '1' : '0',
          'Due Duration': Number(this.dueDurationFields.dueDurationValue),
          'Duration Type': durationType[postBody.DueDurationType] ?? null,
          Compare: this.dueDurationFields.dueDurationCompareValue?.['key'] || null,
          'Date Field': this.dueDurationFields.dueCompareDateFieldValue?.['representation'] || null,
          'Trans Mode': this.selectedTransMode?.['Description'] || null,
        };

        if (this.isAddingStatus) {
          this.defaultStatusList.push({ ...display, ...postBody });
        }

        if (this.popUpAction === 'N') {
          this.hideColumns = Object.keys(postBody);
        }
      }

      this.reloadTableFunc();
      this.popUpAction = 'E'; //Mainly if popUpAction is N
      this.addStatusCancelButtonClick();
    },
    onClickEditStatus() {
      if (this.selectedDefaultStatusList.length === 0) {
        this.$showAlert('error', 'No Status Selected', 'Please select a status to remove', [{ text: 'OK' }]);
        return;
      }
      this.isAddingStatus = false;
      this.showAddNewStatusPopup = true;
      this.clearSelectedFields();
      this.selectedAddStatus = this.addStatusList.getSelected(
        this.selectedDefaultStatusList[0]['Status Code'],
        'Status',
      );
      this.selectedCargoType = this.cargoTypeList.getSelected(
        this.selectedDefaultStatusList[0]['Cargo Type'],
        'Cargo Type',
      );
      this.selectedTransMode = this.transModeList.getSelected(
        this.selectedDefaultStatusList[0]['TransMode'],
        'Trans Mode',
      );
      this.dgCargoChecked = this.selectedDefaultStatusList[0]['DGCargo?'] !== '0';
      this.dueDurationFieldTicked = this.selectedDefaultStatusList[0]['Due Duration'] > 0;

      this.dueDurationFields.dueDurationValue = this.selectedDefaultStatusList[0]['Due Duration']?.toString();
      this.dueDurationFields.dueDurationTypeValue = this.dueDurationDropDown.dueDurationTypeList.getSelected(
        this.selectedDefaultStatusList[0]['DueDurationType'],
        'value',
      );
      this.dueDurationFields.dueDurationCompareValue = this.dueDurationDropDown.dueDurationCompareList.getSelected(
        this.selectedDefaultStatusList[0]['DueDurationCompare'],
        'value',
      );
      this.dueDurationFields.dueCompareDateFieldValue = this.dueDurationDropDown.dueCompareDateFieldList.getSelected(
        this.selectedDefaultStatusList[0]['DueCompareDateField'],
        'DateField',
      );
    },
    clearSelectedFields() {
      this.selectedAddStatus = null;
      this.selectedCargoType = null;
      this.selectedTransMode = null;
      this.dgCargoChecked = false;
      this.dueDurationFields.dueDurationValue = '0';
      this.dueDurationFields.dueDurationTypeValue = null;
      this.dueDurationFields.dueDurationCompareValue = null;
      this.dueDurationFields.dueCompareDateFieldValue = null;
    },
    async onClickAddStatus() {
      this.clearSelectedFields();
      this.isAddingStatus = true;

      if (this.popUpAction === 'N') {
        //Duplicate check when user at create default status page
        this.$fullscreenLoading('Getting Default Status List'); //Get latest
        const jsonBody = {
          customer: this.selectedCustomer?.['Customer Code'] || 'DEFAULT',
          system: this.selectedSystem['System'],
          jobtype: this.selectedJobType['Job Type'],
        };
        const getDefaultStatusList = await this.$apiCallV2('/DefaultStatusList/GetDefaultStatusList', jsonBody);
        if (getDefaultStatusList.length > 0) {
          this.$showAlert('warning', 'Duplicate Default Status Group', 'Please choose another which does not exist');
          this.$fullscreenLoading();
          return;
        }

        this.$fullscreenLoading();
      }

      this.showAddNewStatusPopup = true;
    },
    async saveDefaultStatus() {
      const jsonBody = {
        defaultstatuslistdata: this.defaultStatusList.map((item) => {
          return {
            //For inserting to statustaskdefaults
            status: item['Status Code'],
            cargotype: item['Cargo Type'],
            transmode: item.TransMode,
            dgcargo: item['DGCargo?'],
            dueduration: item['Due Duration'],
            duedurationtype: item.DueDurationType,
            duedurationcompare: item.DueDurationCompare,
            duecomparedatefield: item.DueCompareDateField,
            duecomparetimefield: item.DueCompareTimeField,
            duecomparefieldtable: null,
            userid: item['User'],
          };
        }),
        customer: this.customerInput,
        system: this.systemInput,
        jobtype: this.jobTypeInput,
      };

      await this.$apiCallV2('/DefaultStatusList/UpdateDefaultStatusList', jsonBody);
      this.$fullscreenLoading('Reloading Results');

      await this.latestStatusList();

      // Switch back to view mode
      this.viewMode = true;
      this.popUpTitle = 'View Default Status List';
      this.popUpAction = 'V';

      this.successMessages.push('Default status list saved successfully.');
      this.reloadTableFunc();
      this.$fullscreenLoading();
    },
    reloadTableFunc() {
      this.reloadTable = false;

      this.$nextTick(() => {
        this.reloadTable = true;
      });
    },
    removeStatusClicked: function () {
      if (this.selectedDefaultStatusList.length === 0) {
        this.$showAlert('error', 'No Status Selected', 'Please select a status to remove', [{ text: 'OK' }]);
        return;
      }

      const selectedStatusIndex = this.findSelectedIndex();

      this.defaultStatusList.splice(selectedStatusIndex, 1);
      for (let i = selectedStatusIndex; i < this.defaultStatusList.length; i++) {
        this.defaultStatusList[i]['#'] -= 1;
      }

      this.reloadTableFunc();
    },
    swapStatus(index1, index2) {
      [this.defaultStatusList[index2]['#'], this.defaultStatusList[index1]['#']] = [
        this.defaultStatusList[index1]['#'],
        this.defaultStatusList[index2]['#'],
      ];

      [this.defaultStatusList[index2], this.defaultStatusList[index1]] = [
        this.defaultStatusList[index1],
        this.defaultStatusList[index2],
      ];
    },
    checkStatusLength() {
      if (this.selectedDefaultStatusList.length === 0) {
        this.$showAlert('error', 'No Status Selected', 'Please select a status to move', [{ text: 'OK' }]);
      }
    },
    statusReorderingMenuMoveUpClicked: function () {
      this.checkStatusLength();

      const selectedStatusIndex = this.findSelectedIndex();

      if (selectedStatusIndex === 0) {
        //already at the top of the list
        return;
      }

      this.swapStatus(selectedStatusIndex, selectedStatusIndex - 1);
      this.selectedDefaultStatusList = [this.defaultStatusList[selectedStatusIndex - 1]];
      this.reloadTableFunc();
    },
    statusReorderingMenuMoveDownClicked: function () {
      this.checkStatusLength();

      const selectedStatusIndex = this.findSelectedIndex();

      if (selectedStatusIndex === this.defaultStatusList.length - 1) {
        //already at the bottom of the list
        return;
      }

      this.swapStatus(selectedStatusIndex, selectedStatusIndex + 1);

      this.reloadTable = false;
      this.selectedDefaultStatusList = [this.defaultStatusList[selectedStatusIndex + 1]];
      this.reloadTableFunc();
    },
    async onSystemSelect() {
      this.selectedJobType = null;
      if (this.selectedSystem === null) {
        this.systemFieldErrorMessage = 'Field Missing';
        return;
      }
      this.jobTypeList = await this.$apiCallV2('/Master/GetListMaster', {
        masterfile: 'JOBTYPE',
        module: this.selectedSystem?.['System'],
      });
      this.dueDurationDropDown.dueCompareDateFieldList = await this.$apiCallV2('/Master/GetListMaster', {
        masterfile: 'GETREPRESENTATION',
        module: this.selectedSystem?.['System'],
      });
      this.$nextTick(() => {
        // In case user can still save/click on buttons after the check for a valid default status that can be created
        this.viewMode = true;
      });
    },
    async populateMenu() {
      if (this.selectedStatusList.length == 0 && this.popUpAction !== 'N') {
        this.$showAlert('error', 'No Default Status List Selected', 'Please select a record to view');
        return;
      }
      if (this.popUpAction === 'N') {
        this.defaultStatusList = [];
        this.selectedDefaultStatusList = [];
        this.selectedSystem = null;
        this.selectedJobType = null;
        this.selectedCustomer = null;
      } else {
        this.$fullscreenLoading('Getting Job Type');
        this.jobTypeList = await this.$apiCallV2('/Master/GetListMaster', {
          masterfile: 'JOBTYPE',
          module: this.selectedStatusList[0]['System'],
        });

        this.selectedCustomer = this.customerList.getSelected(
          this.selectedStatusList[0]['Customer Code'],
          'Customer Code',
        );
        this.selectedJobType = this.jobTypeList.getSelected(this.selectedStatusList[0]['Job Type'], 'Job Type');
        this.selectedSystem = this.systemList.getSelected(this.selectedStatusList[0]['System'], 'System');
        this.$fullscreenLoading();
      }

      this.popupEntryShow = true;
      if (this.popUpAction !== 'N') {
        this.customerInput = this.selectedStatusList[0]['Customer Code'];
        this.systemInput = this.selectedStatusList[0]['System'];
        this.jobTypeInput = this.selectedStatusList[0]['Job Type'];
        const jsonBody = {
          customer: this.customerInput,
          system: this.systemInput,
          jobtype: this.jobTypeInput,
        };
        this.dueDurationDropDown.dueCompareDateFieldList = await this.$apiCallV2('/Master/GetListMaster', {
          masterfile: 'GETREPRESENTATION',
          module: this.selectedStatusList[0]['System'],
        });
        this.$fullscreenLoading('Getting Default Status List');
        this.defaultStatusList = await this.$apiCallV2('/DefaultStatusList/GetDefaultStatusList', jsonBody);
        this.hideColumns = Object.keys(this.defaultStatusList?.[0]).slice(12);
        const seqStartAtZero = this.defaultStatusList[0]['SeqNo'] == 0;
        const transform = this.defaultStatusList.map((key) => {
          return {
            '#': seqStartAtZero ? key.SeqNo + 1 : key.SeqNo,
            ...key,
          };
        });
        this.defaultStatusList = transform;
        this.reloadTableFunc();
        this.$fullscreenLoading();
      }
    },
    resetFields() {
      this.systemInput = '';
      this.customerInput = '';
      this.jobType = '';
      this.systemFieldErrorMessage = '';
      this.jobTypeFieldErrorMessage = '';
      this.successMessages = [];
      this.selectedDefaultStatusList = [];
    },
    handleMenuClick: async function (menu) {
      this.resetFields();

      switch (menu.title) {
        case 'View Default Status List': {
          this.viewMode = true;
          this.popUpTitle = 'View Default Status List';
          this.popUpAction = 'V';
          await this.populateMenu();
          break;
        }

        case 'Edit Default Status List': {
          this.viewMode = false;
          this.popUpTitle = 'Edit Default Status List';
          this.popUpAction = 'E';
          await this.populateMenu();
          break;
        }
        case 'Create New Default Status List': {
          this.viewMode = true;
          this.popUpTitle = 'Create Default Status List';
          this.popUpAction = 'N';
          await this.populateMenu();
          break;
        }
        case 'Delete Default Status List': {
          this.popUpAction = 'D';
          if (this.selectedStatusList.length == 0) {
            this.$showAlert('error', 'No Default Status List Selected', 'Please select a record to delete');
            return;
          }
          const deleting = await this.$showAlert(
            'warning',
            'Delete Default Status List',
            `Are you sure you want to delete this Default Status List?`,
            [
              { text: 'Delete', textColor: 'white', color: 'red' },
              { text: 'Cancel', textColor: 'black', color: 'lightgray' },
            ],
          );

          if (deleting == 'Cancel') {
            return;
          }

          this.defaultStatusList = [];
          this.customerInput = this.selectedStatusList[0]['Customer Code'];
          this.systemInput = this.selectedStatusList[0]['System'];
          this.jobTypeInput = this.selectedStatusList[0]['Job Type'];
          this.saveDefaultStatus();
        }
      }
    },
  },
  async mounted() {
    await this.sasControlFunction();
    this.$fullscreenLoading('Getting Data');
    await this.latestStatusList();
    this.systemList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SYSTEM', module: 'LOG' });
    this.customerList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CUSTOMER' });
    this.transModeList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'TRANSMODEDESC' });
    this.cargoTypeList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CARGOTYPE' });
    this.loginDetails = await this.$apiCallV2('/Login/GetDetails');
    this.addStatusList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'STATUS' });
    this.addStatusList = this.addStatusList.map((item) => {
      return {
        ...item,
        combined: `${item.Status} - ${item['Status Desc']}`,
      };
    });
    this.$fullscreenLoading();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.defaultstatuslist-main {
  padding: 5px 45px;
  font-size: 12px;
  display: flex;
  height: 100%;
  > .right-container {
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    width: 100%;
    margin-left: 5px;
    overflow: hidden;
  }
  > .addNewStatus-popup-container {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1500;

    > .addNewStatus-popup {
      height: auto;
      width: 40%;
      padding: 10px;
      display: flex;
      flex-direction: column;
      background-color: white;
      border-radius: 5px;

      > .addNewStatus-button {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 10px;

        > button {
          margin: 0 3px 0 3px;
        }
      }
    }
  }
}

.popup-entry-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  > .popup-top-section {
    display: flex;
    flex-direction: row;
  }

  > .defaultStatusTask-tablebox {
    height: 100%;
    display: flex;
    flex-direction: row;
    min-height: 0;

    > .defaultStatusTask-table-buttons {
      display: flex;
      flex-direction: column;
      margin-top: 40px;

      > button {
        text-align: left;
        width: 120px;

        &:not(:first-child) {
          margin-top: 5px;
        }

        > img {
          height: 20px;
          width: 20px;
        }
      }
    }
    > .defaultStatusTask-table-main-content {
      margin-left: 5px;
      flex: 1;
      display: flex;
      flex-direction: column;
      min-width: 0;
    }
  }
}
</style>
